// How to reach Eighty Days, for the places the site tells a partner to get in
// touch. One module rather than a literal per component, because these appear in
// the footer, the inquiry form and the error page — and a number that is wrong
// in one of three places is worse than no number at all.

export const contactEmail = 'product@80days.co.jp';

/**
 * The desk line, in a form `tel:` accepts (`+81312345678`).
 *
 * Empty until someone fills it in, and every caller hides the invitation to ring
 * rather than showing a dead link. Set it here and it appears everywhere at
 * once.
 */
export const contactPhone: string = '+81367308485';

/** The same number as a person would read it. Falls back to the dialable form. */
export const contactPhoneDisplay: string = '+81 3 6730 8485';

export function contactPhoneLabel(): string {
  return contactPhoneDisplay || contactPhone;
}
